/**
 * Stage4GovernanceNote — a static footer block rendered inside Stage
 * 4's workspace just below the QC panel content. Complements the
 * always-on ComplianceFooter (rendered in the app shell) with an
 * action-oriented, stage-specific reminder at the moment of drafting
 * completion when the drafter is most likely thinking about export.
 *
 * Scope rules per the PRD:
 *   - Stage 4 ONLY. Do not mount on Stages 1, 2, 2.5, 3.
 *   - Placed between QC panel content and the acknowledgment row
 *     (Item 2). In the current Stage 4 layout the ack row sits at
 *     the existing stage controls, so this note ends up immediately
 *     below the QC findings list.
 *   - No interactivity. Static copy, no dismiss.
 *
 * The copy is graded against the governance-review checklist — keep
 * it verbatim unless the PRD revision updates it.
 */
import React from 'react';


export default function Stage4GovernanceNote({
  className = '',
}: {
  className?: string;
}) {
  return (
    <div
      data-testid="stage-4-governance-note"
      className={
        'text-xs text-zinc-500 border-t border-zinc-200 pt-3 mt-4 '
        + 'leading-relaxed '
        + className
      }
    >
      Detailed AI-use logs and governance data for this matter are
      available on demand in line with epi guidelines. Contact the
      tool administrator or request the matter activity export via
      Diagnostics.
    </div>
  );
}
